<template>
  <v-card class="" :color="ant">
    <v-card-title>
      <v-badge
        bordered
        bottom
        color="deep-purple accent-4"
        dot
        offset-x="10"
        offset-y="10"
      >
        <v-avatar color="grey">
          <img
						v-if="avatarURl"
            :src="avatarURl"
            alt="John"
          />
					<span v-else class='text-h3'> {{ order.customer.nickname ? trimFirtTwo(order.customer.nickname) :  order.customer.id  }} </span>
        </v-avatar>
      </v-badge>
      <div class="text-body-2 ml-2 d-flex flex-column">
        <span> {{ order.customer.nickname ? order.customer.nickname: order.customer_id }} </span>
        <span> Customer </span>
      </div>
      <v-spacer></v-spacer>
      <div class="text-body-2 d-flex flex-column">
        <span class="align-self-end">
          <flag :iso="order.customer.country_code ? order.customer.country_code.toLowerCase() : 'ke'" /> {{ customerTime ? customerCurrentTime : 'N/A' }}</span
        >
        <span>Customer Local Time</span>
      </div>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text class="d-flex">
      <div class="d-flex flex-column">
        <span> Orders</span>
        <span> {{ order.customer.total_orders }} </span>
      </div>
      <v-spacer></v-spacer>
      <div class="d-flex flex-column">
        <span> Acceptance Rate</span>
        <span class="green--text"
          >{{ order.customer.acceptance_rate }}%
        </span>
      </div>
      <v-spacer></v-spacer>
      <div class="d-flex flex-column">
        <span> Pay Rate</span>
        <span class="green--text">{{ order.customer.pay_rate }}%</span>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import colorMxn from "@/mixins/colorMxn";
import timezoneMxn from '@/mixins/timezone_mixin';

export default {
  name: "customerRating",
  props: ["order"],
  mixins: [colorMxn, timezoneMxn],
  data() {
    return {
    };
  },
  computed: {
    avatarURl() {
      const url = this.order.customer.avatar ? `${process.env.VUE_APP_BASE_URL}/avatar/download/${this.order.customer.avatar}` : null;
      return url;
    },
	},
  mounted() {
    this.getCustomerTime();
  },
  methods: {
    trimFirtTwo (val) {
			const trimmed = val.match(/.{1,2}/g)[0];
			return trimmed.toUpperCase();
		},
  }
};
</script>
